module.exports = __webpack_public_path__ + "static/media/Zamzama (closeup of plaque) c. 1946.df176e1c.jpg";